import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  Renderer2,
  ViewChild,
  OnInit,
  OnChanges,
  AfterViewInit,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import * as FileSaver from "file-saver";
import { debounceTime, distinctUntilChanged, Subject } from "rxjs";
import {
  Table,
  TableFilterEvent,
  TableLazyLoadEvent,
  TableModule,
} from "primeng/table";
import saveAs from "file-saver";
import { GenericFilterRequestDto } from "../../../../core/models/generic-filter-request.dto";
import { GenericRequestDto } from "../../../../core/models/generic-request.dto";
import { GenericSortRequestDto } from "../../../../core/models/generic-sort-request.dto";
import { GetAllSamplepo } from "../../../../core/models/samplePO/details/getAllSamplepo";
import { DateFilter } from "../../../../core/models/shared/dateFilter";
import { ClientsListingService } from "../../../../core/services/clients-listing.service";
import { SharedService } from "../../../../core/services/shared.service";
import { SidebarService } from "../../../../core/services/sidebar.service";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { Router } from "@angular/router";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { CommonModule } from "@angular/common";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { SamplepoSummaryComponent } from "../samplepo-summary/samplepo-summary.component";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { FilterMetadata } from "primeng/api";

@UntilDestroy()
@Component({
  selector: "jni-samplepo-listing",
  templateUrl: "./samplepo-listing.component.html",
  styleUrls: ["./samplepo-listing.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    DateFilterComponent,
    SamplepoSummaryComponent,
    ModalStackerComponent,
    HidedynamicsdatePipe,
    ButtonModule,
    CardModule,
    InputTextModule,
    SpinnerComponent,
  ],
})
export class SamplepoListingComponent
  implements OnDestroy, OnInit, OnChanges, AfterViewInit
{
  @Input() ponumber: string;
  @Output() scrollHiddenStatus = new EventEmitter();

  lazyLoadEvent: TableLazyLoadEvent = {
    filters: {},
    first: 0,
    globalFilter: null,
    multiSortMeta: undefined,
    rows: 20,
    sortField: undefined,
    sortOrder: 1,
  };

  samplePOListings: GetAllSamplepo[] = [];
  filteredDataSamplePOLists: GetAllSamplepo[] = [];
  selectedSamplePO: GetAllSamplepo[] = [];
  showLoader = false;
  filterDebounceTime = 1000;
  filterTextChanged: Subject<
    Event | DateFilter | GetAllSamplepo[] | undefined
  > = new Subject<Event | DateFilter | GetAllSamplepo[] | undefined>();
  samplePOSummaryDisplayModal = false;
  totalRecords = 0;
  defaultTake = 50;
  samplePOIdFromModal = "";
  samplePOListingModalStatus = false;

  excelRequest: GenericRequestDto = {} as GenericRequestDto;
  filterMode = "server";
  createdDateFieldName = "createdDate";
  createdDateFitler = {} as DateFilter;
  userRole = 0;
  enumUserRole = UserRole;
  @Input() isModal = false;
  @Output() closeModalEvent = new EventEmitter();

  @ViewChild("dt") table!: Table;

  constructor(
    private _router: Router,
    private _samplepoListingService: SamplepoListingService,
    public _clientsListingService: ClientsListingService,
    private renderer: Renderer2,
    private _sidebarService: SidebarService,
    private _sharedService: SharedService,
    private _loginService: UserManagementService,
    private _toastr: JniToastrService
  ) {
    this.ponumber =
      (this._router.getCurrentNavigation()?.extras.state as
        | string
        | undefined) ?? "";
    if (this.ponumber) {
      this.getAllSamplepoListingData(this.lazyLoadEvent);
    }
  }

  ngOnInit(): void {
    if (this._sidebarService.menu$() === "samplepo") {
      this.samplePOSummaryDisplayModal = false;
    }

    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
    this.getUserProfile();
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe(res => {
        this.userRole = res.data.userRoleId;
      });
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  ngOnChanges() {
    if (this.ponumber) {
      this.samplePOListingModalStatus = true;
    }
  }

  ngAfterViewInit() {
    if (this.ponumber) {
      if (this.table) {
        this.table.filters["purchaseOrderNumber"] = {
          value: this.ponumber,
          matchMode: "startsWith",
        };
      }
    }
  }

  viewAfterInIt() {
    if (this.ponumber) {
      if (this.table) {
        this.table.filters["purchaseOrderNumber"] = {
          value: this.ponumber,
          matchMode: "startsWith",
        };
      }
    }
  }

  getCurrentSamplePo(accountnumber: string) {
    if (accountnumber) {
      this.samplePOIdFromModal = accountnumber;
      this.samplePOSummaryDisplayModal = true;
    }
    //this._router.navigate(['/samplepo/samplepo-summary/' + accountnumber]);
  }

  onSamplePORedirection() {
    this._router.navigate(["samplepo/add-samplepo"]);
  }

  getAllSamplepoListingData(event: TableLazyLoadEvent) {
    this.lazyLoadEvent = event;
    this.showLoader = true;
    const eventFilterArray = Object.keys(event.filters ?? {});
    let filter: GenericFilterRequestDto[] = eventFilterArray.map(x => {
      const tableFilter = event?.filters?.[x] as FilterMetadata;
      return {
        columnName: x ?? "",
        matchMode: tableFilter.matchMode ?? "",
        tableName: "",
        value: tableFilter.value ?? "",
      } as GenericFilterRequestDto;
    });
    if (this.ponumber) {
      if (filter.length) {
        const filterObject = filter.filter(
          x => x.columnName === "purchaseOrderNumber"
        );
        if (filterObject.length > 0) {
          filter[0].value = filterObject[0].value;
        }
      } else {
        filter = [
          {
            columnName: "purchaseOrderNumber",
            matchMode: "startsWith",
            tableName: "",
            value: this.ponumber,
          },
          {
            columnName: "vendorName",
            matchMode: "startsWith",
            tableName: "",
            value: "",
          },
          {
            columnName: "jobName",
            matchMode: "startsWith",
            tableName: "",
            value: "",
          },
          {
            columnName: "bcName",
            matchMode: "startsWith",
            tableName: "",
            value: "",
          },
          {
            columnName: "status",
            matchMode: "startsWith",
            tableName: "",
            value: "",
          },
        ];
      }
    }
    const sortArray: GenericSortRequestDto[] =
      event.multiSortMeta?.map(x => {
        return {
          ...x,
        } as GenericSortRequestDto;
      }) ?? [];
    filter.forEach(x => {
      if (x.columnName == "purchaseOrderNumber") {
        x.columnName = "PurchaseOrderNumberD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "vendorName") {
        x.columnName = "VendorOrganizationNameD365";
        x.tableName = "Vendor";
      }
      if (x.columnName == "jobName") {
        x.columnName = "JobNameD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "bcName") {
        x.columnName = "FirstName,LastName";
        x.tableName = "Employee";
      }
      if (x.columnName == "status") {
        x.columnName = "PurchaseOrderStatusD365";
        x.tableName = "PurchaseOrderHeader";
      }
      if (x.columnName == "customerName") {
        x.columnName = "NameAliasD365";
        x.tableName = "Client";
      }

      const createdDate =
        this._sharedService.convertDateFormat(
          this.createdDateFitler.startDate ?? ""
        ) +
        "|" +
        this._sharedService.convertDateFormat(
          this.createdDateFitler.endDate ?? ""
        );
      if (x.columnName == "createdDate") {
        x.columnName = "CreatedDate";
        x.tableName = "PurchaseOrderHeader";
        x.matchMode = this.createdDateFitler.selectedMatchMode;
        x.value = createdDate;
      }
    });
    const request: GenericRequestDto = {
      skip: event.first ?? 0,
      take: event.rows ?? this.defaultTake,
      filters: filter,
      sort: sortArray,
    };

    this.excelRequest = request;

    this._samplepoListingService
      .getAllSamplePOPaginated(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showLoader = false;
          this.samplePOListings = res.data;
          this.filteredDataSamplePOLists = this.samplePOListings;
          this.totalRecords = res.totalRecords ?? 0;
        },
      });
  }

  exportExcel() {
    this.showLoader = true;
    this.exportExcelForFilterData(this.filteredDataSamplePOLists);
    this.showLoader = false;
  }

  exportExcelAll() {
    this.showLoader = true;

    this._samplepoListingService
      .getAllSamplePOExcel(this.excelRequest)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: Blob) => {
          this.showLoader = false;
          this.downloadFile(res);
        },
        error: () => {
          this.showLoader = false;
        },
      });
  }

  downloadFile(data: Blob) {
    const file = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(file, `SamplePOList_export_${new Date().getTime()}.xlsx`);
  }

  exportExcelForFilterData(filterclientlist: GetAllSamplepo[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Sample PO #"]: (datum.purchaseOrderNumber! as string)
          .toLowerCase()
          ?.includes("temp")
          ? ""
          : datum.purchaseOrderNumber,
        ["Vendor Name"]: datum.vendorName,
        ["Account Number"]: datum.orderVendorAccountNumber,
        ["Job Name"]: datum.jobName,
        ["Client Name"]: datum.organizationNameD365,
        ["BC Name"]: datum.bcName,
        ["Status"]: datum.status,
        ["Created By"]: datum.createdBy,
        ["Created Date"]: new Date(datum.createdDate),
        ["Project ID"]: datum.projectId,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "SamplePOList");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  checkboxSelection() {
    if (this.selectedSamplePO.length > 1 || this.selectedSamplePO.length == 0) {
      this._clientsListingService.setAttachmentState(true);
    } else {
      this._clientsListingService.setAttachmentState(false);
    }
  }

  onFilterInput(
    $event: Event | DateFilter | GetAllSamplepo[] | undefined,
    value = ""
  ) {
    if (value === "clear") {
      this.clearFilter();
    }
    if ($event && "startDate" in $event && $event.startDate) {
      this.createdDateFitler = $event;
    }
    if (this.filterTextChanged.observers.length === 0) {
      this.filterTextChanged
        .pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged())
        .subscribe(() => {
          this.getAllSamplepoListingData(this.lazyLoadEvent);
        });
    }
    this.filterTextChanged.next($event);
  }

  deletePurchaseOrder() {
    const selectedPo = this.selectedSamplePO[0];
    if (selectedPo?.purchaseOrderNumber) {
      const purchaseOrderNumber = selectedPo.purchaseOrderNumber;
      this.showLoader = true;
      this._samplepoListingService
        .deleteDraftSamplePo(purchaseOrderNumber)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showLoader = false;
            if (res.status.toLowerCase() === "success") {
              this._toastr.success(
                res.message || `Purchase Order Deleted Successfully`,
                `Success`
              );
            } else {
              this._toastr.error(
                res.message || `Error While Deleting Purchase Order`,
                `Error`
              );
            }

            this.selectedSamplePO = [];
            this.getAllSamplepoListingData(this.lazyLoadEvent);
          },
          error: () => {
            this.showLoader = false;
          },
        });
    }
  }

  closeModalFromSamplePOSummary() {
    this.samplePOSummaryDisplayModal = false;
  }

  closeModalFromSamplePOSummaryRefresh() {
    this.samplePOSummaryDisplayModal = false;
    this.selectedSamplePO = [];
    this.getAllSamplepoListingData(this.lazyLoadEvent);
  }

  addScollHiddenClass() {
    if (this.samplePOListingModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    } else {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  clearFilter() {
    this.createdDateFitler = {} as DateFilter;
  }

  onFilter(event: TableFilterEvent) {
    if (Object.keys(event.filteredValue).length !== 0) {
      this.filteredDataSamplePOLists = event.filteredValue;
    } else {
      this.filteredDataSamplePOLists = this.samplePOListings;
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
